import { useQuery } from '@tanstack/react-query';
import { fetchSecurityGroups } from '../services/security-groups';
import type { SecurityGroupListFilters } from '../types/security-admin.types';

export function useSecurityGroupsQuery(filters: SecurityGroupListFilters = {}) {
  return useQuery({
    queryKey: ['security-groups', filters],
    queryFn: () => fetchSecurityGroups(filters),
    placeholderData: (prev) => prev,
  });
}
